import { render, staticRenderFns } from "./architecture.vue?vue&type=template&id=eab382d6&scoped=true"
import script from "./architecture.vue?vue&type=script&lang=js"
export * from "./architecture.vue?vue&type=script&lang=js"
import style0 from "./architecture.vue?vue&type=style&index=0&id=eab382d6&prod&lang=scss&scoped=true"
import style1 from "./architecture.vue?vue&type=style&index=1&id=eab382d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab382d6",
  null
  
)

export default component.exports